export const MODULES_IDS = {
    TAREAS: 12,
    COMUNICADOS: 14,
    COMUNICACION: 13
}